import { IdSvrAuthService } from "../auth/idSrvAuthService";

export class UserManagerExtension {
    private authService: IdSvrAuthService;

    public static componentName = "UserManagerExtension";
    static $inject = [IdSvrAuthService.componentName];

    constructor(authService: IdSvrAuthService) {
        this.authService = authService;
    }

    public async getUserAndSubstitutionMsnuIds(): Promise<string[]> {
        try {
            const currentUser = await this.authService.getCurrentUserProfile();
            const currentUserLogin = currentUser?.Login!;
            const userSubstitutions = currentUser?.UserSubstitutions || [];
            return _.union(
                [currentUserLogin],
                userSubstitutions.map(x => x.MsnuUserId)
            );
        } catch (error) {
            // Handle or log the error appropriately
            console.error("Error fetching user and substitution MSNU IDs:", error);
            throw error; // or handle it as needed
        }
    }
}

angular.module("topline.app").service(UserManagerExtension.componentName, UserManagerExtension);
